import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { usePurchases } from '../../contexts/PurchasesContext';
import { Loading } from './Loading';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const RouteController: React.FC<PrivateRouteProps> = ({ children }) => {
  const { loading, isAnonymous } = useAuth();
  const { coinBalance, isUserPremium } = usePurchases();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAnonymous && (coinBalance > 10 || isUserPremium)) {
      navigate('/purchase-finalize');
    }
  }, [loading, isAnonymous, coinBalance, isUserPremium, navigate]);

  if (loading) {
    return <Loading />;
  }

  return <>{children}</>;
};
